import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DeleteButtonStyled = styled(Button)<{ error?: boolean }>(({ error }) => {
  if (error) {
    return {
      border: '1px solid red',
      color: 'red'
    }
  }

  return {}
})
